import { cx } from '@linaria/core';
import { TranscriptButton } from '@pm2/element-toolbar';
import { ImageComponent, makeEmptyImageCaption } from '@pm2/image-component';
import { printAST } from '@utils/ast';
import { UniversalContextMenu } from '@utils/component-framework';
import { iGuideHtmlNodeJsxPrinters } from './spec.html.js';
import { imageWrapper, contextMenu, latexFormula, figure } from './spec.image.comp.style.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function ContextImage(props) {
  const image = /*#__PURE__*/jsx(Fragment, {
    children: !props.node.latex ? /*#__PURE__*/jsxs("div", {
      className: imageWrapper,
      "data-with-long-description": !!props.node.longDesc,
      children: [!!props.node.longDesc?.length && /*#__PURE__*/jsx(UniversalContextMenu, {
        togglerClassName: contextMenu,
        layout: "solid",
        label: "\xC5bn kontekstmenuen",
        children: /*#__PURE__*/jsx(TranscriptButton, {
          nodeType: "image-component",
          transcript: props.node.longDesc
        }, "transcript")
      }), /*#__PURE__*/jsx(ImageComponent, {
        caption: makeEmptyImageCaption(),
        displayCaption: undefined,
        enlargeOnClick: true,
        enableScaling: props.node.cssWidth !== undefined,
        link: undefined,
        context: "component-framework",
        imageSrc: props.node.src,
        imageAlt: props.node.alt,
        imageHeight: props.node.dimensions?.height,
        imageWidth: props.node.dimensions?.width,
        cssMaxWidth: props.node.cssWidth,
        transcript: props.node.longDesc,
        node: {
          id: undefined,
          nodeType: "image-component",
          imageSrc: props.node.src,
          link: undefined,
          meta: {
            caption: makeEmptyImageCaption(),
            alt: props.node.alt,
            imageHeight: props.node.dimensions?.height,
            imageWidth: props.node.dimensions?.width
          },
          options: {
            displayCaption: "above",
            enableFullWidth: false,
            enableScaling: props.node.cssWidth !== undefined,
            enlargeOnClick: true
          },
          pm2: {
            enableLightboxButton: false,
            enableNewWindowButton: false,
            enableNotebookButton: false,
            isScrambled: false,
            learningObjectId: undefined,
            learningObjectTitle: undefined,
            pdfExport: {
              headerImage: undefined,
              lineCount: false,
              template: "source"
            },
            pdfFileUrl: undefined,
            ribbonIconId: undefined,
            speechFileUrl: undefined,
            transcript: undefined
          }
        }
      })]
    }) :
    /*#__PURE__*/
    // eslint-disable-next-line @next/next/no-img-element
    jsx("img", {
      role: "presentation",
      alt: props.node.alt ?? "",
      src: props.node.src,
      "data-latex": props.node.latex,
      className: cx(props.node.latex && latexFormula)
    })
  });
  if (!props.node.caption) {
    return image;
  }
  return /*#__PURE__*/jsxs("figure", {
    className: cx("richtext--image-wrapper", figure),
    children: [image, /*#__PURE__*/jsx("figcaption", {
      className: "richtext--image-caption",
      children: printAST(props.node.caption, {
        ...iGuideHtmlNodeJsxPrinters
      })
    })]
  });
}

export { ContextImage as default };
//# sourceMappingURL=spec.image.comp.js.map
